import { Injectable } from '@angular/core';
import { Store } from '@core/classes/store.class';
import { BaseParamsDTO } from '@core/interfaces/dto/base-params-dto.interface';
import { FjalaPerzgjedhurLeksikografi } from '@core/interfaces/models/fjala-perzgjedhur-leksikografi';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class FjalaPerzgjedhurLeksikografiService extends Store<FjalaPerzgjedhurLeksikografi, BaseParamsDTO, unknown, unknown> {
  constructor(apiService: ApiService) {
    super(apiService, 'fjalaPerzgjedhurLeksikografi/');
  }
}
